import styled from 'styled-components';

export const Content = styled.div`
  min-height: 100vh;
  width: 100%;
  padding: 8px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: 992px) {
    padding: 84px 24px 12px 112px;
  }
`;

export const Container = styled.div<{
  maxWidth?: string;
}>`
  margin: 0 auto;
  max-width: ${({ maxWidth }) => maxWidth ?? '100%'};
  width: 100%;
`;

export const ContentHeader = styled.div<{
  maxWidth?: string;
  reservations?: boolean;
}>`
  ${({ reservations, maxWidth }) => {
    if (reservations) {
      return `
        width: 100%;
        max-width: 742px;
        margin: 0 auto;
        padding: 12px 32px 12px 0;
      `;
    }

    const padding = maxWidth ? '12px 0' : '12px 32px';

    return `
      @media (min-width: 992px) {
        padding: ${padding};
      }
    `;
  }}
`;

export const Button = styled.button`
  height: 40px;
  width: max-content;
  padding: 0 12px 0 8px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 4px;
  background-color: transparent;

  > span {
    font-weight: 700;
    font-size: 12px;
    color: #161d1f;
  }

  &:hover {
    background-color: #fed4d6;
  }

  &:focus {
    background-color: #fdadb3;
  }
`;

export const HeaderInfo = styled.div<{
  isTwo?: boolean;
}>`
  display: flex;
  flex-wrap: wrap;
  gap: 4px 0;

  > div {
    > img {
      margin-right: 4px;
    }

    > div {
      > p {
        white-space: nowrap;
      }
    }

    &:not(:last-child)::after {
      content: '|';
      display: inline-block;
      margin: 0 14px;
    }

    @media (max-width: 639px) {
      &:nth-of-type(2)::after {
        display: none;
      }
    }
  }

  @media (max-width: 639px) {
    max-width: ${({ isTwo }) => (isTwo ? '100%' : '360px')};
  }
`;
